<template>
  <button
    @click="handleButtonClick"
    class="gradient-ripple-btn"
    :class="{ [extra_class]: !!extra_class }"
  >
    <div id="ripple-container" class="ripple-wrapper"></div>

    <slot />
  </button>
</template>

<script>
export default {
  props: {
    handle_click: {
      required: true,
      type: Function,
    },
    extra_class: {
      type: String,
      required: false,
    },
  },

  methods: {
    handleButtonClick(event) {
      this.handleRipple(event)

      this.handle_click(event)
    },

    handleRipple(event) {
      const button = event.currentTarget

      const { top, left } = button.getClientRects()[0]

      const { clientY: clickedYPosition, clientX: clickedXPosition } = event

      const isBtnClick = top + button.clientHeight > clickedYPosition

      if (!isBtnClick) return

      const circle = document.createElement('span')

      const diameter = Math.max(button.clientWidth, button.clientHeight)
      const radius = diameter / 2

      // This is here because 'scoped' was not properly applying
      // the styles of the class, since its recreation
      circle.style.position = 'absolute'
      circle.style.width = `${diameter}px`
      circle.style.height = `${diameter}px`
      circle.style.left = `${clickedXPosition - (left + radius)}px`
      circle.style.top = `${clickedYPosition - (top + radius)}px`
      circle.style.borderRadius = '50%'
      circle.style.transform = 'scale(0)'
      circle.style.animation = 'ripple 800ms linear'
      circle.style.backgroundColor = 'rgba(255, 255, 255, 0.7)'

      const wantedClass = 'ripple-download'
      circle.classList.add(wantedClass)

      const container = document.getElementById('ripple-container')

      const ripple = container.getElementsByClassName(wantedClass)[0]

      if (ripple) ripple.remove()

      container.appendChild(circle)
    },
  },
}
</script>

<style lang="scss" scoped>
.gradient-ripple-btn {
  @include flexMiddle;
  border: none;
  outline: none;
  background: linear-gradient(40deg, #45cafc, #303f9f);
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.3);
  user-select: none;
  border-radius: 2px;
  text-transform: uppercase;
  color: #fff;
  position: relative;
  padding: 8px 24px;

  > span {
    margin: 0 8px;
  }

  transition: box-shadow 0.2s ease;

  svg {
    @include boxSizing(14);
  }
}

.ripple-wrapper {
  overflow: hidden;
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 100%;
}
</style>
